<template>
  <div class="address">
    <div class="row-label"><p v-html="getLabel()"></p></div>
    <div class="address-wrap">
      <div v-if="!(address.first_name === 'dealer' && address.last_name ==='dealer')">
        <p>{{ address.first_name }} {{ address.last_name }}</p>
      </div>
      <p>{{ address.company }} {{ address.nip }}</p>
      <p>{{ address.street }}</p>
      <p>{{ address.post_code }} {{ address.city }}</p>
      <p>{{ address.phone_number}}</p>
    </div>
  </div>
</template>

<script>
  import store from "./../../store/index"
  export default {
    name: "DisplayAddress",
    props: {
      type: String,
    },
    computed: {

      address() {
        switch(this.type)
        {
          case 'billing':
            return store.getters.billingAddress;
            break;
          case 'shipping':
            return store.getters.shippingAddress;
            break;
        }
      }
    },
    methods: {
      getLabel() {
        return window.translations['CART_address_' + this.type];
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Cart/DisplayAddress.vue